import React from "react";
import {connect} from "react-redux";
import {getSessionStorageItem} from "../../../misc/storageFunctions";
import {setAdminToolSettingsPopupVisible} from "./adminActions";
import {IS_SUPER_ADMIN} from "../../../config";
import PropTypes from "prop-types";
import {featureInterface} from "../../../interfaces/featureInterface";


const SuperAdminFeatureToolSettingsButton = (props) => {

  const {setAdminToolSettingsPopupVisible, feature} = props;

  const isLoggedAsAdmin = IS_SUPER_ADMIN && getSessionStorageItem("superAdminToken", false);
  if (!isLoggedAsAdmin || !feature) {
    return null
  }

  const handleButtonClick = () => {
    setAdminToolSettingsPopupVisible(true, feature);
  }

  return (
    <button className={"feature-toolSettings"} onClick={handleButtonClick}/>
  )
};

SuperAdminFeatureToolSettingsButton.propTypes = {
  feature: PropTypes.shape(featureInterface).isRequired,
}

const mapStateToProps = (store) => {
  const {adminLoginPopupVisible, adminLogoutVisible} = store.adminState;
  return {
    adminLoginPopupVisible, // to update component when it changes
    adminLogoutVisible, // to update component when it changes
  };
};

const mapDispatchToProps = {
  setAdminToolSettingsPopupVisible,
};

export default connect(mapStateToProps, mapDispatchToProps)(SuperAdminFeatureToolSettingsButton)
